export const APP = {
  ENV: process.env.REACT_APP_ENV,
  PUBLIC_URL: process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/` : "/",
  prefixPublicUrl: ({ url }: { url: string }) => {
    return (process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/` : "/") + url;
  },
};
